/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/assets/js/sticky-cart.js ***!
  \**************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StickyCart = /*#__PURE__*/function (_HTMLElement) {
  function StickyCart() {
    var _this;
    _classCallCheck(this, StickyCart);
    _this = _callSuper(this, StickyCart);
    _this.initializeElements();
    _this.init();
    return _this;
  }
  _inherits(StickyCart, _HTMLElement);
  return _createClass(StickyCart, [{
    key: "initializeElements",
    value: function initializeElements() {
      this.stickyCartSection = this.querySelector('.sticky-cart-section');
      this.stickyVariantButtons = this.querySelectorAll('.sticky-cart-section .variant-input');
      this.stickyAddToCartButton = this.querySelector('#sticky__add-to-cart');
      this.stickyPrice = this.querySelector('.sticky__product-price');
      this.variantButtons = document.querySelectorAll('.product-block .variant-input');
      this.addToCartButton = document.querySelector('.add-to-cart-btn');
      this.productBlock = document.querySelector('.product-content');
      this.appstleWidget;
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      //this.initVariantSelector();
      this.initPriceObserver();
      this.initAppstleWidgetObserver();
      this.initAddToCartButton();
      document.addEventListener('scroll', function () {
        return _this2.showStickyCart();
      });
    }
  }, {
    key: "showStickyCart",
    value: function showStickyCart() {
      if (window.scrollY >= 1000) {
        var _this$stickyCartSecti;
        (_this$stickyCartSecti = this.stickyCartSection) === null || _this$stickyCartSecti === void 0 || _this$stickyCartSecti.classList.add('sticky-cart--visible');
      } else {
        var _this$stickyCartSecti2;
        (_this$stickyCartSecti2 = this.stickyCartSection) === null || _this$stickyCartSecti2 === void 0 || _this$stickyCartSecti2.classList.remove('sticky-cart--visible');
      }
    }

    //initVariantSelector() {
    //  const stickyVariantButtons = document.querySelectorAll('.sticky-cart-section .variant-input');
    //  stickyVariantButtons.forEach((button) => {
    //    button.addEventListener('click', (e) => this.onVariantClick(button, e));
    //  });
    //}

    //onVariantClick(clickedVariantButton, e) {
    //  e.preventDefault()
    //  this.stickyVariantButtons.forEach(button => button.classList.remove('selected'));
    //  clickedVariantButton.classList.add('selected');

    //  let selectedValueInput = ''

    //  if(clickedVariantButton.querySelector('input')){
    //    selectedValueInput = clickedVariantButton.querySelector('input').value
    //  }

    //  this.variantButtons.forEach(button => {
    //    if(button.querySelector('input')){
    //      const valueInput = button.querySelector('input').value
    //      if (selectedValueInput === valueInput) {
    //        const label = button.querySelector('label')
    //        if(label){
    //          label.click();
    //        }
    //      }
    //    }
    //  });
    //}
  }, {
    key: "initAddToCartButton",
    value: function initAddToCartButton() {
      var _this3 = this;
      this.stickyAddToCartButton.addEventListener('click', function () {
        if (_this3.variantButtons && _this3.variantButtons.length > 0 || _this3.appstleWidget) {
          _this3.productBlock.scrollIntoView();
        } else {
          var _this3$addToCartButto;
          (_this3$addToCartButto = _this3.addToCartButton) === null || _this3$addToCartButto === void 0 || _this3$addToCartButto.click();
        }
      });
    }
  }, {
    key: "initPriceObserver",
    value: function initPriceObserver() {
      var _this4 = this;
      var targetNode = document.querySelector('.product-block-price');
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      var callback = function callback(mutationList, observer) {
        var _iterator = _createForOfIteratorHelper(mutationList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.type === 'childList') {
              _this4.renderPrice();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      var observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  }, {
    key: "initAppstleWidgetObserver",
    value: function initAppstleWidgetObserver() {
      var _this5 = this;
      var targetNode = this.productBlock;
      var config = {
        attributes: true,
        childList: true,
        subtree: true
      };
      var callback = function callback(mutationList, observer) {
        var _iterator2 = _createForOfIteratorHelper(mutationList),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mutation = _step2.value;
            if (mutation.type === 'childList') {
              _this5.appstleWidget = document.querySelector('#appstle-widget-template');
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
      var observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  }, {
    key: "renderPrice",
    value: function renderPrice() {
      var _document$querySelect, _document$querySelect2, _document$querySelect3;
      var priceValue = (_document$querySelect = document.querySelector('.product-block-price [data-product-price]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.textContent;
      var priceDiscountedValue = (_document$querySelect2 = document.querySelector('.product-block-price [data-compare-price]')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.textContent;
      var pricePercentageValue = (_document$querySelect3 = document.querySelector('.product-block-price [data-saving-percentage-price]')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.textContent;
      if (this.stickyPrice) {
        var stickyPrice = this.stickyPrice.querySelector('[data-product-price]');
        var stickyDiscountedPrice = this.stickyPrice.querySelector('[data-compare-price]');
        var stickyPercentageValue = this.stickyPrice.querySelector('[data-saving-percentage-price]');
        if (stickyPrice && priceValue) {
          stickyPrice.innerHTML = priceValue;
          stickyPrice.setAttribute('data-product-price', priceValue);
        }
        if (stickyDiscountedPrice && priceDiscountedValue) {
          stickyDiscountedPrice.innerHTML = priceDiscountedValue;
          stickyDiscountedPrice.setAttribute('data-compare-price', priceDiscountedValue);
        }
        if (stickyPercentageValue && pricePercentageValue) {
          stickyPercentageValue.innerHTML = pricePercentageValue;
          stickyPercentageValue.setAttribute('data-saving-percentage-price', pricePercentageValue);
        } else {
          stickyPercentageValue === null || stickyPercentageValue === void 0 || stickyPercentageValue.classList.add('tw-hidden');
        }
      }
    }
  }, {
    key: "checkIfSoldOut",
    value: function checkIfSoldOut() {
      var submitButton = document.querySelector('.product-form__inner .product-form__cart-submit');
      if (submitButton && this.stickyAddToCartButton) {
        this.stickyAddToCartButton.disabled = submitButton.disabled;
      }
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('product-sticky-cart')) {
  customElements.define('product-sticky-cart', StickyCart);
}
/******/ })()
;